import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Typography,
  Alert,
  Stack,
} from '@mui/material';
import { startRegistration } from '@simplewebauthn/browser';
import axios from 'axios';

const tiers = ['Tier1', 'Tier2', 'Tier3', 'Tier4'];

const AgencyRegisterScreen = () => {
  const [formData, setFormData] = useState({
    agencyName: '',
    agencyAddress: '',
    agencyPhone: '',
    agencyEmail: '',
    agencyTier: '',
    password:"",
  });

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [registering, setRegistering] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    setRegistering(true);

    try {
      // 1. Request registration options from server
     const { data: options } = await axios.post('/api/webauthn/agency/generate-registration-options', {
  agencyEmail: formData.agencyEmail,
  agencyName: formData.agencyName, // ✅ Add this
});

      // 2. Start registration with WebAuthn
     //console.log("frontend  options  ", options) 

      const credential = await startRegistration(options);

     //console.log("frontend credential  ", credential )

      // 3. Send response + agency details to server
      const { data } = await axios.post('/api/webauthn/agency/register', {
        credential,
        agencyData: formData,
      });

      setMessage(data?.message || 'Agency registered successfully.');
    } catch (err) {
      setError(err.response?.data?.message || 'Registration failed.');
    } finally {
      setRegistering(false);
    }
  };

  return (
    <Box maxWidth="sm" mx="auto" mt={4}>
      <Typography variant="h5" gutterBottom>
        Agency Registration (WebAuthn)
      </Typography>
      <form onSubmit={handleRegister}>
        <Stack spacing={2}>
          <TextField
            label="Agency Name"
            name="agencyName"
            value={formData.agencyName}
            onChange={handleChange}
            required
            fullWidth
          />
          <TextField
            label="Address"
            name="agencyAddress"
            value={formData.agencyAddress}
            onChange={handleChange}
            required
            fullWidth
          />
          <TextField
            label="Phone"
            name="agencyPhone"
            value={formData.agencyPhone}
            onChange={handleChange}
            required
            fullWidth
          />
          <TextField
            label="Email"
            name="agencyEmail"
            value={formData.agencyEmail}
            onChange={handleChange}
            required
            fullWidth
            type="email"
          />
           <TextField
            label="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            fullWidth
          />
          <TextField
            label="Tier"
            name="agencyTier"
            select
            value={formData.agencyTier}
            onChange={handleChange}
            required
            fullWidth
          >
            {tiers.map((tier) => (
              <MenuItem key={tier} value={tier}>
                {tier}
              </MenuItem>
            ))}
          </TextField>
          <Button
            variant="contained"
            type="submit"
            disabled={registering}
          >
            {registering ? 'Registering...' : 'Register Agency'}
          </Button>
          {message && <Alert severity="success">{message}</Alert>}
          {error && <Alert severity="error">{error}</Alert>}
        </Stack>
      </form>
    </Box>
  );
};

export default AgencyRegisterScreen;
